
export const ENDPOINTS = {
  LOGIN: "Authenticate/authenticateUser",
  USERCHECK: "Authenticate/UserCheck",
  REFRESH_TOKEN: "Authenticate/refreshToken",
  GET_TOKEN: "Authenticate/getToken",
  GET_REFRESH_TOKEN_LOGIN: "Authenticate/getRefreshTokenLogin",
  GET_MENU: "Authenticate/getmenurights",
  mantainanceBanner: "Authenticate/mantainanceBanner",
  LOCATIONTYPE_MASTER: "Location/getLocationTypeMasterList",
  LOCATIONTYPE_SAVE: "Location/saveLocationType",
  FACILITYSETUPLIST: "Location/getFacilitySetupMasterList",
  BUILDING_SAVE: "Location/saveFacilitySetup",
  BUILDING_GET: "Authenticate/GetFacilityList",
  BUILDING_DETAILS: "Location/getFacilityDetails",
  GETLOCATIONTYPE: "Location/getLocationMasterList",
  LOCATION_SAVE: "Location/saveLocationSetup",
  GETHIRARCHY_LIST: "Location/getLocationHierarchyList",
  PASTE_LOCATION: "Location/coppyPasteLocationStructure",
  DELETE_LOCATION: "Location/deleteLocationStructure",
  LOCATION_DETAILS: "Location/getLocationDetails",
  SKILL_MASTER: "Masters/getUserMasterList",
  GET_LANGUAGE: "Authenticate/getLanguage",
  SAVE_LANGUAGE: "Authenticate/changeUserDefaultLanguage",
  SAVE_SKILL_MASTER: "Masters/saveSkillMaster",
  USERSKILLMASTER: "Masters/getUserSkillList",
  GETUSEROPTIONS: "Masters/getUserDetailsMasterList",
  GETROLETYPE: "Masters/getRoleTypeMasterList",
  saveUserRoleMaster: "Masters/saveUserRoleMaster",
  getUserSkillMasterList: "Masters/getUserSkillMasterList",
  getUserDetailsList: "Masters/getUserDetailsList",
  Roles_Right: "Masters/getUserRoleRightsList",
  ROLES_RIGHT_SAVE: "Masters/SaveUserRoleRightsMaster",
  SAVE_MAKE_MASTER: "Asset/saveMakeMaster",
  SAVE_MODEL_MASTER: "Asset/saveModelMaster",
  SAVE_ASSET_GROUP_MASTER: "Asset/saveAssetGroupMaster",
  SAVE_ASSET_TYPE_MASTER: "Asset/saveAssetTypeMaster",
  GET_ASSET_MASTER_LIST: "Asset/getAssestMastersList",
  // GET_SCHDULE_LIST:  "Asset/getScheduleList",
  getTaskMasterList: "Asset/getTaskMasterList",
  SAVE_UOMMASTER: "Asset/saveUomMaster",
  getUserSkillDetails: "Masters/getUserSkillDetails",
  saveUserSkillMaster: "Masters/saveUserSkillMaster",
  USERMASTER_SAVE: "Masters/saveUserDetailsMaster",
  getConfigurationsMastersList: "Configurations/getConfigurationsMastersList",
  getAssestMasterList: "Asset/getAssestMasterList",
  saveSeverityMaster: "Configurations/saveSeverityMaster",
  updatePasswordConfigMaster: "Configurations/updatePasswordConfigMaster",
  deleteSeverityMaster: "Configurations/deleteSeverityMaster",
  WORKODRDERTYPE_LIST: "Configurations/getConfigurationsMastersList",
  WORKORDERTYPE_STATUS: "Configurations/saveWOTypeStatusMaster",
  CURRENTCONFIGSTATUSAVE: "Configurations/saveCurrentStatusMaster",
  CURRENTCONFIGSTATUS_DELETE: "Configurations/deleteCurrentStatusMaster",
  STOREMASTER_LIST: "Inventory/getInventoryMastersList",
  STOREMASTER_SAVE: "Inventory/saveStoreMaster",
  STOREMASTER_DELETE: "Inventory/deleteStoreMaster",
  LOCATION_HIERARCHY_LIST: "Inventory/getLocationHierarchyList",
  //Weekof master
  WEEKOFMASTERLIST: "Workforce/getWorkForceMastersList",
  SAVEWEEKOFMASTER: "Workforce/saveWeekOffMaster",

  //Request master Description
  GET_MATERIAL_LIST: "Maintenance/getMaintenanceMastersList",
  GET_REQUEST_DETAILS: "Maintenance/getReqDetailsList",
  //DropDown
  GET_REQUEST_DESCRIPTION_MASTERLIST:
    "Maintenance/getRequestDescriptionMasterList",
  GET_SCHEDULE_MASTERLIST:
    "Asset/getscheduleMasterListInfra",

  MASTERREQUESTDESCRIPTION_SAVE: "Maintenance/saveRequestDescriptionMaster",
  MASTERREQUEST_DELETE: " Maintenance/deleteRequestDescriptionMaster",
  RACKMASTER_SAVE: "Inventory/saveRackMaster",
  ASSETMASTERCONFIGURATION_SAVE: "Configurations/saveAssetMasterConfigurations",
  //...........vendor Master
  VENDORMASTER_SAVE: "Inventory/saveVendorMaster",
  //...............Asset Master
  GETASSETMASTEROPTIONS: "Asset/getAssestMasterList",
  ASSETMASTER_SAVE: "Asset/saveAssetMaster",
  SCHEDULE_SAVE: "Asset/saveSchedule",
  ASSETMASTER_DETAILS: "Asset/getAssetDetailsList",
  SCHEDULE_LIST: "Asset/getScheduleList",
  TASK_LIST: "Asset/getTaskList",
  GET_SCHEDULE_DETAILS: "Asset/getScheduleDetails",
  saveNumberRangeConfig: "Configurations/saveNumberRangeConfig",
  // Delete Endpoints
  DELETE_MAKEMASTER: "Asset/deleteMakeMaster",
  DELETE_MODELMASTER: "Asset/deleteModelMaster ",
  DELETE_UOMMASTER: "Asset/deleteUomMaster ",
  DELETE_ASSETTYPEMASTER: "Asset/deleteAssetTypeMaster ",
  DELETE_ASSETGROUPMASTER: "Asset/deleteAssetGroupMaster ",
  DELETE_ASSETTASKANDSCHEDULE: "Asset/deleteSchedule ",
  // DELETE_SERVICETYPEMASTER:"Asset/deleteAssetT",
  DELETE_USERMASTER: "Masters/deleteUserMaster ",
  DELETE_SKILLMASTER: "Masters/deleteSkillMaster",
  DELETE_PARTMASTER: "Asset/deletePartMaster",
  DELETE_ROLEMASTER: "Masters/deleteRoleMaster ",
  DELETE_STOREMASTER: "Inventory/deleteStoreMaster",
  DELETE_CURRENTSTATUS: "Configurations/deleteCurrentStatusMaster",
  DELETE_RACKMASTER: "Inventory/deleteRackMaster",
  DELETE_VENDORMASTER: "Inventory/deleteVendorMaster",
  DELETE_ASSETMASTER: "Asset/deleteAssetMaster",
  DELETE_WEEKOFMASTER: "Workforce/DeleteWeekOffMaster",
  DELETE_TASKMASTER: "Asset/deleteTaskMaster",
  DELETE_REQUESTDESCRIPTIONMASTER: "Maintenance/deleteRequestDescriptionMaster",
  // Save Endpoints
  saveTaskMaster: "Asset/saveTaskMaster",
  savePartMaster: "Asset/savePartMaster",
  // ASSETMASTER_SAVE:"Asset/saveAssetMaster",
  //Get Details
  getPartDetailsList: "Asset/getPartDetailsList",

  // ASSETMASTER_DETAILS:"Asset/getAssetDetailsList",
  DefaultFacility: "Authenticate/setUserDefaultFacility",
  //TeamMaster
  GETLOCATIONTEAMOPTION: "Workforce/getAssetTypeTeamLeadMastersList",
  SAVE_TEAMMASTER: "Workforce/saveTeamMaster",
  GET_WORKFORCELISTOPTION: "Workforce/getWorkforceByTeamList",
  GET_LOCATIONLIST: "Workforce/getLocationByTeamList",
  GET_WORKFORCE_DELETE: "Workforce/deleteTeamMaster",
  //EventMaster Api
  GET_EVENTMASTER: "Helpdesk/getHelpdeskMastersList",
  GET_EVENTMASTER_OPTIONS: "Helpdesk/getEventMasterList",
  GET_EVENTMASTER_STATUS: "Helpdesk/getEventTypeStatusList",
  GET_EVENTMASTER_PARALIST: "Helpdesk/getEventParaList",
  SAVE_EVENTMASTER: "Helpdesk/saveEventMaster",
  EDIT_EVENTMASTER_OPTION: "Helpdesk/getEventMasterDetails",
  DELETE_EVENTMASTER: "Helpdesk/deleteEventMaster",

  EVENT_NOTIFICATION: "Maintenance/saveEventNotification",
  // Event Escalation
  GET_EVENT_Escalation_OPTIONS: "Helpdesk/getEventEscalationMasterList",
  SAVE_EVENT_Escalation: "Helpdesk/saveEventEscalationMaster",
  GET_EVENT_Escalation_OPTIONS_DETAILS: "Helpdesk/getEventEscalationMasterDetails",
  DELETE_ESCALALTION: "Helpdesk/deleteEventEscalationMaster",
  //PPM Schedule
  GET_PPM_SCHEDULE_DASHBOARD: "Maintenance/getScheduleDashBoard",
  GET_PPM_SCHEDULE_DETAILS: "Maintenance/getPpmScheduleById",
  UPDATE_PPM_SCHEDULE_DETAILS: "Maintenance/updatePpmSchedule",
  ADD_PPM_SCHEDULE: "Maintenance/savePpmSchedule",
  GET_ASSETNAME: "Maintenance/getAssetPpmSchedule",
  //Inventory
  GET_INVENTORY_MASTER_OPTIONS: "Inventory/getInventoryMasterList",
  GET_INVENTORY_PARTLIST: "Inventory/getAddInventoryMasterPartList",
  GET_MATERIAL_REQUISITION_DETAILS: "Inventory/getMaterialRequisitionDetails",
  SAVE_INVENTORY_MATERIAL_REQUISITION: "Inventory/saveMaterialRequisition",
  GETINVENTORYMASTERLIST: "Inventory/getInventoryMasterList",
  SAVEADDINVENTORYMASTER: "Inventory/saveAddInventoryMaster",
  GETINVENTORYMASTERSLIST: "Inventory/getInventoryMastersList",
  GETADDINVENTORYMASTERSDETAILS: "Inventory/getAddInventoryMasterDetails",
  GETINVENTORYMASTERPARTLIST: "Inventory/getAddInventoryMasterPartList",
  CANCEL_INVENTORY: "Inventory/cancleAddInventoryMaster",
  SAVEISSUEMATERIAL: "Inventory/saveIssueMaterial",
  GET_RETURN_MATERIAL_DETAILS: "Inventory/getReturnMaterialDetails",
  SAVE_RETURN_MATERIAL_DETAILS: "Inventory/saveRetrunMaterial",
  GETINVENTORY: "Invnetory/GetInventoryMasterList",
  SAVE_STORETOSTORE: "Inventory/saveStoreToStoreTransfer",
  //Service Request
  GET_SERVICEREQUST_MASTERLIST: "Helpdesk/getServiceRequestMasterList",
  GET_SERVICEREQUEST_WORKORDER: "Helpdesk/getWOReqList",
  SAVE_SERVICEREQUEST: "Helpdesk/saveServiceRequest",
  GET_SERVICEREQUEST_DETAILS: "Helpdesk/getServiceRequestDetails",
  GETEXCELTEMPLATECOMMON: "Upload/getExcelTemplateCommon",
  GET_TECHNICIANLIST: "Helpdesk/getTechnicianList",
  GET_ASSETGROUPTEAMLIST: "Helpdesk/getAssetGroupTeamList",
  //Workorder
  SAVE_WORKORDER: "Helpdesk/saveWorkOrder",
  GET_WORKORDER_DETAILS: "Helpdesk/getWorkOrderDetails",
  UPLOADEXCELDATACOMMON: "Upload/uploadExcelDataCommonWithoutEncryption",
  SET_WORKSTATUS_Api: "Helpdesk/setWoStatus",
  SAVE_WO_TASK_PART: "Helpdesk/saveWoTaskPartDetails",
  REDIRECT_WO: "Helpdesk/saveRedirectWo",
  GET_PARTS: "Inventory/getReturnMaterialDetails",
  SAVE_USEDPARTS: "Helpdesk/saveUsedMaterial",
  SAVE_FDDASSETMASTER: "Asset/saveFddAssetMaster",
  saveObemAssetMaster: "Asset/saveObemAssetMaster",
  GET_ASSET_GROUP_CHECK: "Helpdesk/assetgroupAssignCheck",

  //save reason master
  SAVE_REASON_MASTER: "Configurations/saveReasonMaster",
  DELETE_REASON_MASTER: "Configurations/deleteReasonMaster",
  SAVE_ACTIVITY_TRACKER: "Authenticate/saveUserActivity",
  GET_TASK_MASTER_DETAILS: "Asset/getTaskMasterDetails",

  // Dashboard 
  GET_DASHBOARD_MASTER: "DashBoard/getDashboardMastersList",
  GET_DASHBOARD_DETAILS: "DashBoard/getDashboardDetailsList",
  //Download Data

  GET_EXCEL_DOWNLOADDATA: "Masters/MastersDownloadData",
  //RectifyComment
  SAVE_RECTIFIEDMASTER: "Helpdesk/saveRectifiedComment",
  FILE_SACNNING: "https://api-us1.scanii.com/v2.2/files%22",
  GET_DOCLIST: "Helpdesk/getdocList",
  GETLOGSDETAILS: "Configurations/getLogDetails",
  GETLOGSLIST: "Configurations/getLogList",
  SAVECONTRACTMASTER: "Inventory/saveContractMaster",
  GETCONTRACTLIST: "Inventory/getContractList",
  GETCONTRACTMASTERDETAILS: "Inventory/getcontractMasterDetails",
  SAVE_VENDOR_SOR: "VendorM/savevendorSOR",
  VENDORE_SOR_MANAGEMENTLIST: "VendorM/getVendorManagementMastersList",
  VENDOR_SOR_DETAILS: "VendorM/getVendorSorDetails",
  VENDOR_SOR_COMPARISION_LIST: "VendorM/getVendorSorComarisionPartList",
  DOC_UPLOAD_CHECK_old: "Helpdesk/docUploadCheck",
  DOC_UPLOAD_CHECK: "Helpdesk/docUploadCheckWithOutEncryption",
  GETACTIONSTATUSDETAILS: "Masters/getActionStatusDetails",
  // GETACTIONSTATUSDETAILS: "Masters/getActionStatusDetails",
  UPDATEACTIONSTATUSDETAILS: "Masters/updateActionStatusDesc",
  //equipment hierarchy
  SAVE_EQUIPMENT_HIERARCHY: "Equipment/saveEquipmentHierarchy",
  GET_EQUIPMENT_HIERARCHY: "Equipment/getEquipmentHierarchyMasterList",
  DELETE_EQUIPMENT_HIERARCHY: "Equipment/deleteEquipmentHierarchy",

  HierarchyList: "Equipment/getEquipmentHierarchylistwithcode",
  //  "Equipment/getEquipmentHierarchyList",
  ACCOUNT_DELETE: "Authenticate/userDelete",

  //infra service
  GET_INFRA_MASTER_SERVICE_REQUEST: "HelpDeskInfra/getServiceRequestMasterListInfra",
  GET_INFRA_ISSUE_MASTER_SERVICE_REQUEST: "HelpDeskInfra/getIssueDescriptionList",
  GET_INFRA_ASSET_DETAILS: "HelpDeskInfra/getAssetDetailsList",
  // SAVE_INFRA_SERVICE_REQUEST: "HelpDeskInfra/saveServiceRequestDetails",
  SAVE_INFRA_SERVICE_REQUEST: "HelpDeskInfra/saveServiceRequest",
  GET_HIERARCHY_FOLDER_LIST: "HelpDeskInfra/getEquipmentHierarchyWithFolderList",
  UPDATE_WO_INFRA: "HelpDeskInfra/updateWOInfra",
  GET_TEAM_USERLIST_INFRA: "HelpDeskInfra/getTeamUserList",
  UPDATEWOSTATUSINFRA: "HelpDeskInfra/setWoStatus",
  GETWOACTIVELISTINFRA: "HelpDeskInfra/getWOActiveListInfra",
  MASTERREASONLISTINFRA: "MastersInfra/getReasonMasterListInfra",
  MASTERIINFRAREASONSAVE: "MastersInfra/saveReasonMasterInfra",
  GETREASONALLLISTINFRA: "MastersInfra/getReasonMastersListInfra",
  GET_CANCEL_REASON_LIST: "HelpDeskInfra/getReasonlistInfra",
  //equipment hierarchy
  // SAVE_EQUIPMENT_HIERARCHY: "Equipment/saveEquipmentHierarchy",
  // GET_EQUIPMENT_HIERARCHY: "Equipment/getEquipmentHierarchyMasterList",
  // DELETE_EQUIPMENT_HIERARCHY: "Equipment/deleteEquipmentHierarchy",

  // HierarchyList: "Equipment/getEquipmentHierarchyList",
  // ACCOUNT_DELETE: "Authenticate/userDelete",

  //salceforce details
  SALCEFORCE_DETAILS: "Helpdesk/getSalesForceWoContactInfo",
  GET_ACTION_VIEW_LIST: "MastersInfra/getActionViewList",
  FILTER_GET_API: "HelpdeskInfra/getfiltermasterlistInfra",
  FILTER_GET_API_LIST: "HelpdeskInfra/getwofilterdatalist",
  USER_ACTION_STATUS: "MastersInfra/updateactionviewmaster",
  UPDATE_HIERARCHY_LIST: "Equipment/UpdateEquipmentHierarchy",
  GET_COMMON_REPORT_LIST: "Report/getCommonReportList",
  GET_REPORT_DATA: "Report/getReportData",
  COMMON_LOCATION_LIST: "Location/UpdateLocationHierarchy",
  Location_Hierarchy_List: "Equipment/getEquipmentAssetHierarchylistwithcode",
  DELETE_DOC_LIST: 'Helpdesk/deleteDocument',
  INFRA_SAVE_SCHEDULE_LIST: "Asset/saveScheduleAssetInfra",
  REPORT_TEMPLATE_MASTER_LIST: "Report/gettemplatemasterList",
  SAVE_REPORT_TEMPLATE: "Report/savereportteamplate",
  Deleted_Image: "Helpdesk/deleteDocument",
  LOCATION_EQUIPMENT_HIERARCHY_LIST: "Equipment/getLocationHierarchyList",
  deleteRectifyComment: "Helpdesk/DeleteRectifiedComment",
  Image__Upload: "Helpdesk/uploadfilesonaws",
  getOnlyLocationHierarchyList: "Equipment/getOnlyLocationHierarchyList",
  UPDATE_MAINTENANCE:"Authenticate/saveMaintenanceBanner",
  GET_MAINTENANCELIST:"Authenticate/getMaintenancBannerList",
  BANNER_LIST:"Authenticate/getMaintenancBannerAlert",
  GetAnnualScheduleReport: "Report/GetAnnualScheduleReport",
  getEquipmentAssetHierarchylistwithcode:"Equipment/getEquipmentAssetHierarchylistwithcode"
};
